import { fetchApi } from './client';
import type { CpeSearchResult } from './types';

interface SearchCpeVendorsParams {
    q: string;
    limit?: number;
}

interface CpeSearchResponse {
    results: CpeSearchResult[];
}

/**
 * Search for known CPE vendor names.
 */
export async function searchCpeVendors(params: SearchCpeVendorsParams): Promise<CpeSearchResult[]> {
    const searchParams = new URLSearchParams();
    searchParams.set('q', params.q);
    searchParams.set('type', 'vendor');

    if (params.limit !== undefined) {
        searchParams.set('limit', String(params.limit));
    }

    const response = await fetchApi<CpeSearchResponse>(
        `/api/cpe/search?${searchParams.toString()}`,
    );

    return response.results;
}

interface SearchCpeProductsParams {
    q: string;
    vendor: string;
    limit?: number;
}

/**
 * Search for known CPE product names within a given vendor.
 */
export async function searchCpeProducts(
    params: SearchCpeProductsParams,
): Promise<CpeSearchResult[]> {
    const searchParams = new URLSearchParams();
    searchParams.set('q', params.q);
    searchParams.set('type', 'product');
    searchParams.set('vendor', params.vendor);

    if (params.limit !== undefined) {
        searchParams.set('limit', String(params.limit));
    }

    const response = await fetchApi<CpeSearchResponse>(
        `/api/cpe/search?${searchParams.toString()}`,
    );

    return response.results;
}
